import { App } from 'vue';
import ButtonV2 from '../button/src/button-v2.vue';

ButtonV2.install = (app: App): void => {
    app.component(ButtonV2.name, ButtonV2);
};

export default ButtonV2;

declare module 'vue' {
    export interface GlobalComponents {
        PtButtonV2: typeof ButtonV2;
    }
}
